import { c as _c } from "react/compiler-runtime";
import { FaroSelect } from "@components/common/faro-select/faro-select";
import { LabelWithHelp } from "@components/common/label-with-help";
import { ExternalLinks } from "@components/external-links";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { DeleteIcon, Divider, MenuItem } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { formatUserRoleType } from "@utils/data-display";

/** The value of the entry that removes the member, which no role can take */
const REMOVE_VALUE = "remove";

/** An entry below the roles that removes the member instead of changing their role */

/** Shows a selector in which user can choose a role for different subjects, i.e company, project, group */
export function SelectRole(t0) {
  const $ = _c(42);
  const {
    roles,
    disabledRoles: t1,
    variant,
    selectedRole,
    onChange,
    label,
    link,
    isRequired: t2,
    dataTestId,
    menuProps,
    removeOption,
    isDisabled
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const disabledRoles = t3;
  const isRequired = t2 === undefined ? true : t2;
  let t4;
  if ($[2] !== onChange || $[3] !== removeOption) {
    t4 = function onSelectChange(value) {
      if (value === REMOVE_VALUE) {
        removeOption?.onRemove();
        return;
      }
      onChange(value);
    };
    $[2] = onChange;
    $[3] = removeOption;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onSelectChange = t4;
  let t5;
  if ($[5] !== isRequired || $[6] !== label || $[7] !== variant) {
    t5 = variant === "outlined" && <LabelWithHelp title={label} isRequired={isRequired} />;
    $[5] = isRequired;
    $[6] = label;
    $[7] = variant;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== selectedRole) {
    t6 = selectedRole ? () => formatUserRoleType(selectedRole) : undefined;
    $[9] = selectedRole;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== disabledRoles || $[12] !== roles || $[13] !== selectedRole || $[14] !== variant) {
    let t8;
    if ($[16] !== disabledRoles || $[17] !== selectedRole || $[18] !== variant) {
      t8 = role => <MenuItem key={role} value={role} disabled={disabledRoles.includes(role)} sx={getRoleMenuItemSx({
        isTableCell: variant === "borderless"
      })}><RoleMenuItem role={role} isRoleSelected={role === selectedRole} /></MenuItem>;
      $[16] = disabledRoles;
      $[17] = selectedRole;
      $[18] = variant;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t7 = roles.map(t8);
    $[11] = disabledRoles;
    $[12] = roles;
    $[13] = selectedRole;
    $[14] = variant;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[20] !== removeOption) {
    t8 = removeOption && <Divider sx={{
      m: "8px"
    }} />;
    $[20] = removeOption;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== removeOption) {
    t9 = removeOption && <MenuItem value={REMOVE_VALUE} label={removeOption.label} Icon={DeleteIcon} destructive={true} />;
    $[22] = removeOption;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== link) {
    t10 = link && <Box sx={{
      mb: "8px"
    }}><Divider sx={{
        m: "8px"
      }} /><ExternalLinks link={link} text="Learn about permissions levels" sx={{
        fontSize: "12px",
        px: "16px",
        mx: "8px",
        color: "primary.main"
      }} /></Box>;
    $[24] = link;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== dataTestId || $[27] !== isDisabled || $[28] !== label || $[29] !== menuProps || $[30] !== onSelectChange || $[31] !== selectedRole || $[32] !== t10 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9 || $[37] !== variant) {
    t11 = <FaroSelect label={label} dataTestId={dataTestId} variant={variant} value={selectedRole} onChange={onSelectChange} renderValue={t6} menuProps={menuProps} isDisabled={isDisabled}>{t7}{t8}{t9}{t10}</FaroSelect>;
    $[26] = dataTestId;
    $[27] = isDisabled;
    $[28] = label;
    $[29] = menuProps;
    $[30] = onSelectChange;
    $[31] = selectedRole;
    $[32] = t10;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = variant;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t11 || $[40] !== t5) {
    t12 = <>{t5}{t11}</>;
    $[39] = t11;
    $[40] = t5;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
}